import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import BannerSingle from '../../BannerSingle';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import ViverNoticias from '../../ViverMelhor/ViverNoticias';
import "../../Pages/ViverMelhor/styles.css";
import ViverCalendario from '../../ViverMelhor/ViverCalendario';
import ViverMelhorExtraPageLayout from '../../ViverMelhor/ViverMelhorExtraPageLayout';
import CustomPageDescription from '../../PageDescription/CustomPageDescription';
import vivermelhor from "../../../assets/img/vivermelhor/hotsite PVM - Sara_Prancheta 1.png";

class ViverMelhorPage extends Component {

	render() {

		return (

			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<ErrorBoundary><BannerSingle page={"viver-melhor"} image={"viver-melhor"} /></ErrorBoundary>

				{/* Page description */}
				<ErrorBoundary>
					<CustomPageDescription page={"viver-melhor"} />
				</ErrorBoundary>
				{/* Content page */}
				{/* <div className='container'>
					<div className='row justify-content-center'>
						<div className=''>
							<a href={'https://chat.whatsapp.com/Er9dgizhM9hIev16HKQudq'} target='_blank' rel="noreferrer">
								<img style={{ maxWidth: "100%", margin: "30px" }} src={vivermelhor} alt="" />
							</a>
						</div>
						{/* <div style={{ maxWidth: "89%", margin: "30px", backgroundColor: "#e78a12", padding:"20px", color:"#fff" }}>
							Quer receber dicas semanais sobre finanças e investimentos para lidar melhor com o seu dinheiro? <b><a style={{color:"black"}} href={'https://chat.whatsapp.com/Er9dgizhM9hIev16HKQudq'} target='_blank' rel="noreferrer"> Clique aqui </a></b>e entre para o canal do Whatsapp do programa Para Viver Melhor, com a educadora financeira, Sara Marques. Você pode enviar sugestões de vídeos e tirar suas dúvidas!
						</div> 
					</div>
				</div> */}
				<br></br>
				{/* EVENTOS */}
				<div className='container'>

					{/* NOTICIAS */}
					<div className='row justify-content-center'>
						<div className="col-lg-10 col-xl-10">
							<div className="page-description__title"><h4>Notícias do Programa</h4></div>
							<div>
								<ErrorBoundary>
									<ViverNoticias />
								</ErrorBoundary>
							</div>
						</div>
					</div>

					{/* <br></br>	<br></br><br></br><br></br> */}
					{/* <br></br> */}

					<div className='row justify-content-center '>
						<div className="col-lg-10 col-xl-10 section-page">
							<div className="page-description__title mb-lg-5"><h4>Eventos</h4></div>
							<div>Fique por dentro de nossa programação.</div>
							<div>
								<ErrorBoundary>
									<ViverCalendario></ViverCalendario>
								</ErrorBoundary>
							</div>
						</div>
					</div>

					{/* <br></br><br></br><br></br><br></br> */}
					<br></br><br></br>



					<ViverMelhorExtraPageLayout page={"viver-melhor"}></ViverMelhorExtraPageLayout>

				</div>

				<br></br>	<br></br>

				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default ViverMelhorPage;